import React from 'react';
import * as pbi from 'powerbi-client';
import api from '../ApiService';

const powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);

// Supports external site rendering a report using this site
export default class ExternalAccessReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            status: 'Loading...'
        };
    }

    componentDidMount = async () => {
        // Example: https://localhost:44395/#/report/44210d45-c26f-49c7-ac57-0bd1a163a8fd/99C18B61B08A767FD188BD712F481D3EB3ADB3F0352A5ACA8FF8F31E118CF95B
        let route = window.location.hash.split('/');
        if (route[0] !== '#' || route[1] !== 'report' || route.length !== 4)
            throw new Error('Unexpected route in ExternalAccessReport component');

        let report = await api.getReport(route[2], route[3]);
        if (report) {
            this.setState({ status: '' });
            this.embedReport(report);
        }
        else {
            this.setState({ status: 'Unable to load report.' });
        }
    }

    embedReport = async (report) => {
        // Render report
        let config = {
            type: "report",
            tokenType: pbi.models.TokenType.Embed,
            accessToken: report.token,
            embedUrl: report.embedUrl,
            id: report.id,
            permissions: pbi.models.Permissions.All,
            viewMode: pbi.models.ViewMode.View,
            settings: {
                filterPaneEnabled: false,
                navContentPaneEnabled: true
            }
        };

        // Set up container
        let reportContainer = document.createElement('div');
        reportContainer.setAttribute('style', 'width: 1000px; height: 800px;');
        let appPowerBI = document.getElementById('app-powerbi');
        let a = appPowerBI.children[0];
        if (a) {
            appPowerBI.removeChild(a);
        }
        appPowerBI.appendChild(reportContainer);

        // Attach the report
        powerbi.embed(reportContainer, config);
    }

    render() {
        return <div id='app-powerbi'>{this.state.status !== '' && <span>{this.state.status}</span>}</div>;
    }
} 


// WEBPACK FOOTER //
// ./src/components/ExternalAccessReport.js